import { Endowment as Domain, EndowmentField } from 'modules/cm/RepaymentStrategy/Endowment';
import { format } from 'utils/date';
import { Endowment as API } from '../Endowment';

const apiToDomain = (api: API): Domain => ({
  [EndowmentField.Id]: api.id,
  [EndowmentField.Provider]: api.provider,
  [EndowmentField.ExpectedMaturityDate]: api.expectedMaturityDate
    ? format(api.expectedMaturityDate).fromBackendToView()
    : null,
  [EndowmentField.CurrentFundValue]: api.currentFundValue,
  [EndowmentField.MonthlyContribution]: api.monthlyContribution,
});

export default apiToDomain;
